import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptVentas (ventas) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resumen de Ventas",
        Subject: "Ventas",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      data.push([
        // 'Fecha de Registro',
        'Fecha de Comprobante',
        'Fecha de Vencimiento',
        'Cliente',
        'Razón Social',
        'Condición Fiscal',
        'Tipo Documento',
        'Nro. Documento',
        'Tipo Comprobante',
        'Formulario',
        'Número',
        'Monto Gravado',
        'Monto Exento',
        'Monto No Gravado',
        'Monto Iva Insc.',
        'Monto Total',
        'CAE',
        'Fecha Últ Cobro',
        'Presup. Internos',
        'Certificados',
        'Fecha Cert.',
      ]);

      if (ventas.length != 0) {
        ventas.forEach(venta => {
          data.push([
            // this.$options.filters.fecha(venta.fechaRegistro),
            this.$options.filters.fecha(venta.fechaComprobante),
            this.$options.filters.fecha(venta.fechaVencimiento),
            venta.cliente,
            venta.razonSocial,
            venta.condicionFiscal,
            venta.documentoTipo,
            this.$options.filters.documentoNumero(venta.documentoNumero, venta.documentoTipoId),
            venta.comprobanteTipo,
            venta.formulario,
            venta.numeroCompleto,
            venta.montoGravado,
            venta.montoExento,
            venta.montoNoGravado,
            venta.montoIvaInscripto,
            venta.montoTotal,
            venta.cae,
            this.$options.filters.fecha(venta.fechaUltimoCobro),
            venta.presupuestosInternos,
            venta.certificados,
            venta.certificadosFechas
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Ventas");
      XLSX.writeFile(wb, "Ventas.xlsx");

      return;
    },

  }
}
